<template>
    <div class="achievement">
        <div class="container">
            <div class="top-select">
                <el-select v-model="countryValue" class="select" placeholder="请选择" @change="handleRegion">
                    <el-option v-for="item in wholeCountry" :key="item.value" :label="item.label"
                        :value="{ value: item.value, label: item.label }">
                    </el-option>
                </el-select>
                <el-select v-model="companyValue" class="select" placeholder="请选择" @change="handleCompany">
                    <el-option v-for="item in companies" :key="item.value" :label="item.label"
                        :value="{ value: item.value, label: item.label }">
                    </el-option>
                </el-select>
                <el-date-picker v-model="timer" type="year" placeholder="选择年" :picker-options="pickerBeginDateBefore"
                    @change="handleTime">
                </el-date-picker>
            </div>
            <!-- 顶部 -->
            <div class="top-cont">
                <div class="top-cont-left">
                    <dv-border-box-7 class="top-left">
                        <div class="top-dis">
                            <div class="top-left-left">
                                <p class="top-icon top-icon-four" id="top-icon-four">
                                    业绩概况
                                </p>
                                <div class="w1280">
                                    <p class="achievement-title">业绩目标</p>
                                    <p>
                                        <animate-number from="1" class="achievement-num" :to="achievement"
                                            :key="achievement" :formatter="formatter"></animate-number><span
                                            class="number-s">万</span>
                                    </p>
                                </div>

                                <div class="dis-top">
                                    <div>
                                        <p class="achievement-title">累计业绩</p>
                                    </div>
                                    <div class="num-dis">
                                        <!-- <div class="box-items1" id="TNum"></div> -->
                                        <div id="number" class="number"></div>
                                        <p class="num-text">万</p>
                                    </div>
                                </div>
                            </div>
                            <div class="top-left-right">
                                <div class="width-height">
                                    <div id="dataCharts" :style="{ width: '100%', height: '100%' }"></div>
                                </div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="top-cont-right" @mouseover="changIconsBlockPosition('enter', 1)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="middle-data middle-flex">
                            <p class="top-icon top-icon-four" id="top-icon-four">业绩分布</p>
                            <div class="icons-block">
                                <iconsBlock ref="iconsFir" class="cont-position" :timeArray="timerData" @chooseData="childByValue"
                                    :infoTitle="'业绩分布'" :idName="idName1" :stringPaintChart="childByValue"
                                    @download="download" @changeTextColor="changeTextColor"
                                    :details="COUNSTDATE.ACHIEVEMENT_DISTRIBUTION" @fn="fn" />
                            </div>
                        </div>
                        <div class="width-height" id="width-height">
                            <div id="topRight" :style="{ width: '100%', height: '100%' }"></div>
                        </div>
                    </dv-border-box-7>
                </div>
            </div>
            <!-- 中间 -->
            <div class="middle-cont">
                <div class="middle-cont-left">
                    <div class="middle-left-left" @mouseover="changIconsBlockPosition('enter', 2)"
                        @mouseleave="changIconsBlockPosition('out')">
                        <dv-border-box-7>
                            <div class="middle-data middle-flex">
                                <p class="top-icon top-icon-six">人选推荐数据</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsSec" class="cont-position" :timeArray="timerData" @chooseData="childByValue"
                                        :infoTitle="'人选推荐数据'" :idName="idName2" :stringPaintChart="childByValue"
                                        @download="download" @changeTextColor="changeTextColor"
                                        :details="COUNSTDATE.CANDIDATE_RECOMMENDATION" />
                                </div>
                            </div>
                            <div class="width-height">
                                <div id="middleLeft" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </dv-border-box-7>
                    </div>
                    <div class="middle-left-right" @mouseover="changIconsBlockPosition('enter', 3)"
                        @mouseleave="changIconsBlockPosition('out')">
                        <dv-border-box-7>
                            <div class="middle-data middle-flex">
                                <p class="top-icon top-icon-six">人选推荐漏斗</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsThr" class="cont-position" :timeArray="timerData" @chooseData="childByValue"
                                        :infoTitle="'人选推荐漏斗'" :idName="idName3" :stringPaintChart="childByValue"
                                        @download="download" @changeTextColor="changeTextColor"
                                        :details="COUNSTDATE.RECOMMENDED_FUNNEL" />
                                </div>
                            </div>
                            <div class="width-height" style="height: 80%">
                                <div id="middleRight" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </dv-border-box-7>
                    </div>
                </div>
                <div class="middle-cont-right" @mouseover="changIconsBlockPosition('enter', 4)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="middle-data middle-data1">
                            <p class="cont-bg-event">业务顾问职级分布</p>
                            <div class="icons-block">
                                <iconsBlock ref="iconsFou" class="cont-position" :timeArray="timerData" @chooseData="childByValue"
                                    :infoTitle="'业务顾问职级分布'" :idName="idName4" :stringPaintChart="childByValue"
                                    @download="download" @changeTextColor="changeTextColor"
                                    :details="COUNSTDATE.BUSINESS_CONSULTANT" />
                            </div>
                        </div>
                        <div class="middle-right-container">
                            <div class="middle-right-left">
                                <div class="people-img"></div>
                                <p class="p-p">
                                    <animate-number from="1" :to="staffCount" :key="staffCount" class="p-text">
                                    </animate-number>人
                                </p>
                                <p class="p-text-bot">业务顾问</p>
                            </div>
                            <div class="middle-right-right">
                                <div class="width-height" style="height: 90%">
                                    <div id="middleRightTwo" :style="{ width: '100%', height: '100%' }"></div>
                                </div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
            </div>
            <!-- 底部 -->
            <div class="bottom-cont">
                <div class="bottom-dis">
                    <div class="bottom-div" @mouseover="changIconsBlockPosition('enter', 5)"
                        @mouseleave="changIconsBlockPosition('out')">
                        <dv-border-box-7>
                            <div class="middle-data middle-data1">
                                <p class="cont-bg-event">业务顾问学历分布</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsFiv" class="cont-position" :timeArray="timerData" @chooseData="childByValue"
                                        :infoTitle="'业务顾问学历分布'" :idName="idName8" :stringPaintChart="childByValue"
                                        @download="download" @changeTextColor="changeTextColor"
                                        :details="COUNSTDATE.BUSINESS_EDUCATION" />
                                </div>
                            </div>
                            <div class="bottom-height">
                                <div id="bottomOned" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </dv-border-box-7>
                    </div>
                    <div class="bottom-div" @mouseover="changIconsBlockPosition('enter', 6)"
                        @mouseleave="changIconsBlockPosition('out')">
                        <dv-border-box-7>
                            <div class="middle-data middle-data1">
                                <p class="cont-bg-event">业务顾问年龄分布</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsSix" class="cont-position" :timeArray="timerData" @chooseData="childByValue"
                                        :infoTitle="'业务顾问年龄分布'" :idName="idName5" :stringPaintChart="childByValue"
                                        @download="download" @changeTextColor="changeTextColor"
                                        :details="COUNSTDATE.BUSINESS_AGE" />
                                </div>
                            </div>
                            <div class="bottom-height">
                                <div id="bottomTwo" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </dv-border-box-7>
                    </div>
                    <div class="bottom-div" @mouseover="changIconsBlockPosition('enter', 7)"
                        @mouseleave="changIconsBlockPosition('out')">
                        <dv-border-box-7>
                            <div class="middle-data middle-data1">
                                <p class="cont-bg-event">业务顾问工龄分布</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsSev" class="cont-position" :timeArray="timerData" @chooseData="childByValue"
                                        :infoTitle="'业务顾问工龄分布'" :idName="idName6" :stringPaintChart="childByValue"
                                        @download="download" @changeTextColor="changeTextColor"
                                        :details="COUNSTDATE.BUSINESS_WORK_YEAR" />
                                </div>
                            </div>
                            <div class="bottom-height">
                                <div id="bottomThree" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </dv-border-box-7>
                    </div>
                    <div class="bottom-div" @mouseover="changIconsBlockPosition('enter', 8)"
                        @mouseleave="changIconsBlockPosition('out')">
                        <dv-border-box-7>
                            <div class="middle-data middle-data1">
                                <p class="cont-bg-event">业绩等级分布</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsEig" class="cont-position" :timeArray="timerData" @chooseData="childByValue"
                                        :infoTitle="'业绩等级分布'" :idName="idName7" :stringPaintChart="childByValue"
                                        @download="download" @changeTextColor="changeTextColor"
                                        :details="COUNSTDATE.BUSINESS_SEX" />
                                </div>
                            </div>
                            <div class="bottom-height">
                                <div id="bottomFour" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </dv-border-box-7>
                    </div>
                    <div class="bottom-div" @mouseover="changIconsBlockPosition('enter', 9)"
                        @mouseleave="changIconsBlockPosition('out')">
                        <dv-border-box-7>
                            <div class="middle-data middle-data1">
                                <p class="cont-bg-event">业务顾问户籍分布</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsNin" class="cont-position" :infoTitle="'业务顾问户籍分布'"
                                        :idName="'bottomFive'" :stringPaintChart="bottomFiveData" @download="download"
                                        @changeTextColor="changeTextColor"
                                        :details="COUNSTDATE.BUSINESS_HOUSEHOLD_REGISTER" />
                                </div>
                            </div>
                            <div class="bottom-height" style="height: 80%">
                                <div id="bottomFive" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </dv-border-box-7>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { exportImg } from "../../utils/downLoad.js";
import {
    GetRegionalPerfomanceInfo,
    GetRegionalMonthPerfomanceInfo,
    GetRegionalMonthPerfomanceInfoByDateRange,
    GetRegionalBusinessConsultantLocation,
    GetRegionalMonthRecommend,
    GetRegionalMonthRecommendByDateRange,
    GetRegionalRecommendPerson,
    GetRegionalRecommendPersonByDateRange,
    GetRegionalCounselorPPerformance,
    GetRegionalCounselorPPerformanceByDateRange,
    GetRegionalCounselorEducation,
    GetRegionalCounselorEducationByDateRange,
    GetRegionalCounselorWorkyear,
    GetRegionalCounselorWorkyearByDateRange,
    GetRegionalPerformanceGradeByDateRange,
    GetRegionalCounselorAge,
    GetRegionalCounselorAgeByDateRange,
    GetRegionComboBox,
    GetCompaniesData,
    GetRegionalStaffLevelByDateRange,
    GetRegionalCounselorLevel,
    GetRegionalCounselorLevelByDateRange,
} from "@/api/api";
import $ from "jquery";
import { Digit } from "../../assets/js/index.js";
import iconsBlock from "./iconsBlock/index.vue";
import COUNSTDATE from "../../constants/index";

export default {
    components: {
        iconsBlock,
    },
    data() {
        return {
            COUNSTDATE: COUNSTDATE,
            urlData: "",
            achievement: "64535.50", //业绩目标
            chartNum: ["0", "0", "0", "0", "0", "0", "0"],
            isChildText: false,
            idName1:"topRight",
            idName2:"middleLeft",
            idName3:"middleRight",
            idName4:"middleRightTwo",
            idName8:"bottomOned",
            idName5:"bottomTwo",
            idName6:"bottomThree",
            idName7:"bottomFour",
            timer: new Date(),
            countryId: 0,
            countryValue: "",
            wholeCountry: [],
            companyId: 0,
            companyValue: "",
            companies: [],
            checkId: 0,
            performanceAmount: 0,
            staffCount: 0,
            locationData: [],
            pickerBeginDateBefore: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            timerData:[],
            regionId:0,
            companyIded:0,
            curDate:"",
            curDate:"",
        };
    },
    computed: {
        isTextColor() {
            return this.isChildText ? "#000" : "#fff";
        },
        getYear() {
            return new Date(this.timer).getFullYear() || new Date().getFullYear();
        },
        params() {
            return {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                ticket: this.urlData,
            };
        },
    },
    async created() {
        this.urlData = sessionStorage.getItem("urlData");
        await this.comboBoxData();
    },
    async mounted() { 
        this.onClick()
        this.twoClick()
        this.etCountDays()
     },

    methods: {
        etCountDays() {
            let curDate = new Date()
            let curMonth = curDate.getMonth()
            curDate.setMonth(curMonth + 1)
            curDate.setDate(0)
            /* 返回当月的天数和月份 */
            this.curDate=curDate.getDate()
            return { day: curDate.getDate(), month: curMonth + 1 }
        },
        childByValue(data,value,countryValue,companyValue) {
            console.log('[ value ] >', value)
            if (data != undefined){
            this.timerData=value
             var arr=value[1].substring(5,7)
            if(arr=="01"){
                this.curTime="-31"
            }else if(arr=="02"){
                this.curTime="-28"
            }else if(arr=="03"){
                this.curTime="-31"
            }else if(arr=="04"){
                this.curTime="-30"
            }else if(arr=="05"){
                this.curTime="-31"
            }else if(arr=="06"){
                this.curTime="-30"
            }else if(arr=="07"){
                this.curTime="-31"
            }else if(arr=="08"){
                this.curTime="-31"
            }else if(arr=="09"){
                this.curTime="-30"
            }else if(arr=="10"){
                this.curTime="-31"
            }else if(arr=="11"){
                this.curTime="-30"
            }else if(arr=="12"){
                this.curTime="-31"
            }


            this.regionId=countryValue
            this.companyIded=companyValue.value
            }
            if (data == undefined) {
                // if(this.idName1!=""){
                //     this.topRightDataTwo();
                // }
                // if(this.idName2!=""){
                //     this.middleLeftDataTwo();
                // }
                // if(this.idName3!=""){
                //     this.middleRightDataTwo();
                // }
                // if(this.idName4!=""){
                //     this.middleRightTwoDataTwo();
                // }
                // if(this.idName5!=""){
                //     this.bottomTwoDataTwo();
                // }
                // if(this.idName6!=""){
                //     this.bottomThreeDataTwo();
                // }
                // if(this.idName7!=""){
                //     this.bottomFourDataTwo();
                // }
                // if(this.idName8!=""){
                //     this.bottomOnedDataTwo();
                // }
                console.log("[ 123 ] >", 123);

            } else if (data == "topRight") {
                this.topRightDataTwo();
            } else if (data == "middleLeft") {
                this.middleLeftDataTwo();
            } else if (data == "middleRight") {
                this.middleRightDataTwo();
            } else if (data == "middleRightTwo") {
                this.middleRightTwoDataTwo();
            } else if (data == "bottomOned") {
                this.bottomOnedDataTwo();
            } else if (data == "bottomTwo") {
                this.bottomTwoDataTwo();
            } else if (data == "bottomThree") {
                this.bottomThreeDataTwo();
            } else if (data == "bottomFour") {
                this.bottomFourDataTwo();
            }
        },

        //本季度开始
        onClick(picker) {
            var now = new Date(); // 当前日期
            var nowMonth = now.getMonth(); // 当前月
            var nowYear = now.getYear(); // 当前年
            nowYear += (nowYear < 2000) ? 1900 : 0;
            let m = 0;
            if (nowMonth < 3) {//012
                m = 0
            } else if (2 < nowMonth && nowMonth < 6) {//345
                m = 3
            } else if (5 < nowMonth && nowMonth < 8) {//678
                m = 6
            } else if (nowMonth > 8) { //9 10 11
                m = 9
            }
            let quarterStart = new Date(nowYear, m, 1)

            this.formatDate(quarterStart)
        },
        //本季度结束
        twoClick(picker) {
            var now = new Date(); // 当前日期
            var nowMonth = now.getMonth(); // 当前月
            var nowYear = now.getYear(); // 当前年
            nowYear += (nowYear < 2000) ? 1900 : 0;
            let i = 0;
            if (nowMonth < 3) {//012
                i = 3
            } else if (2 < nowMonth && nowMonth < 6) {//345
                i = 6
            } else if (5 < nowMonth && nowMonth < 8) {//678
                i = 9
            } else if (nowMonth > 8) { //9 10 11
                i = 0
            }

            let quarterEnd = new Date(nowYear, i, 1).getTime() - (60 * 60 * 24 * 1000)
            let aa = Date(parseInt(quarterEnd) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ')
            this.formatDate(new Date(aa))
        },

        formatDate(date) {
            var myyear = date.getFullYear();
            var mymonth = date.getMonth() + 1;
            var myweekday = date.getDate();
            if (mymonth < 10) {
                mymonth = "0" + mymonth;
            }
            if (myweekday < 10) {
                myweekday = "0" + myweekday;
            }
            this.timerData.push(myyear + "-" + mymonth)
            return (myyear + "-" + mymonth);
        },



        changeEchartsDate() {
            this.dataChartsData();
            this.topRightData();
            this.middleLeftData();
            this.middleRightData();
            this.middleRightTwoData();
            this.bottomOnedData();
            this.bottomTwoData();
            this.bottomThreeData();
            this.bottomFourData();
            this.bottomFiveData();
            this.startNumed();
        },
        handleRegion(v) {
            if (v.label === this.countryValue) return;
            this.countryId = v.value;
            this.checkId = v.value;
            this.companies = [];
            this.companyValue = "";
            //   this.companyId = 0;
            this.GetCompaniesData();
            this.changeEchartsDate();
        },

        handleCompany(v) {
            this.companyId = v.value;
            this.numData();
            this.changeEchartsDate();
        },
        handleTime(time) {
            this.timer = time;
            this.numData();
            this.changeEchartsDate();
        },
        // 获取全国大区
        comboBoxData() {
            GetRegionComboBox({ ticket: this.urlData }).then((res) => {
                if (res) {
                    this.countryValue = res.Data[0].RegionName;
                }
                this.countryId = res.Data[0].Id; 

                if (res.Data.length >= 0) {
                    this.checkId = res.Data[0].Id;
                }
                res.Data.forEach((e) => {
                    const item = {
                        value: e.Id,
                        label: e.RegionName,
                    };
                    this.wholeCountry.push(item);
                });

                this.GetCompaniesData();
            });
        },
        //获取公司
        GetCompaniesData() {
            let param = {
                regionId: this.countryId,
                ticket: this.urlData,
            };
            GetCompaniesData(param).then((res) => {
                this.companyValue = res[0].Text;
                this.companyId = res[0].CompanyId;
                res.forEach((e) => {
                    const item = {
                        value: e.CompanyId,
                        label: e.Text,
                    };
                    this.companies.push(item);
                });
                this.changeEchartsDate();
            });
        },

        numData() {
            $("#number").html("");
            let dom = document.getElementById("number");
            let digit = new Digit({
                number: this.performanceAmount, // 到达指定数值停止滚动
                finish: 2, // 整体完成时间
                speed: 1, // 数值越大，越多数字同时进行翻滚，取值范围（1 ~ 10）
                direction: "right", // 动画方向
                dom: dom, // 在指定dom节点插入动画
            });
            digit.render();
        },

        //    数字动画
        startNumed() {
            let that = this;
            var strHtml = "";
            for (var i = 0; i < that.chartNum.length; i++) {
                strHtml +=
                    '<p class="number-item1">\n' +
                    '                <span><i class="item2" ref="numberItem">0123456789</i></span>\n' +
                    "            </p>";
            }
            $("#TNum").html(strHtml);

            // 定时改变数字
            // setInterval(function setInted() {
            that.toOrderNumed(this.performanceAmount);
            that.setNumberTransformed();
            // }, 1000);
        },

        toOrderNumed(num) {
            let newnum = num.toString(); // 数字变成字符串
            if (newnum.length) {
                // 如未满位数，添加"0"补位
                const zeroStr = "0000000";
                newnum = (zeroStr + newnum).slice(-7);

                this.chartNum = newnum.split("");
            } else {
                this.$message({
                    showClose: true,
                    message: "显示异常",
                    type: "warning",
                });
            }
        },
        setNumberTransformed() {
            var numberItems = $(".item2");
            const numberArr = this.chartNum.filter((item) => !isNaN(item));
            for (var index = 0; index < numberItems.length; index++) {
                const elem = numberItems[index];
                elem.style.transform =
                    "translate(-50%, -" + numberArr[index] * 10 + "%)";
            }
        },

        formatter: function (num) {
            return num.toFixed(2);
        },
        // 累计业绩
        dataChartsData() {
            let param = this.params;
            GetRegionalPerfomanceInfo(param).then((res) => {
                if (res.Status === 1) {
                    this.achievement = res.Data.PerformanceTarget / 10000;
                    this.performanceAmount = (res.Data.PerformanceAmount / 10000).toFixed(
                        2
                    );
                    var stringNum = (res.Data.CompletedProgress * 100).toFixed(2);
                    // this.startNumed();
                    this.numData();

                    let dataCharts = this.$echarts.init(
                        document.getElementById("dataCharts")
                    );
                    dataCharts.setOption({
                        legend: {
                            data: ["完成进度", "完成进度"],
                            right: "0%",
                            bottom: "10%",
                            left: "center",
                            itemWidth: 0,
                            itemHeight: 0,
                            textStyle: {
                                color: this.isChildText ? "#000" : "#f2f2f2",
                                fontSize: 12,
                            },
                        },
                        series: [
                            {
                                name: "完成进度",
                                radius: "115%",

                                symbolSize: 20,
                                center: ["48%", "60%"],
                                type: "gauge",
                                progress: {
                                    show: true,
                                },

                                axisLabel: {
                                    //文字样式（及“10”、“20”等文字样式）
                                    color: "#fff",
                                    distance: 10, //文字离表盘的距离
                                },
                                detail: {
                                    valueAnimation: true,
                                    offsetCenter: [0, "63%"],
                                    formatter: "{value}%",
                                    textStyle: {
                                        fontSize: 16,
                                        color: "#FFDF38",
                                    },
                                },
                                data: [
                                    {
                                        value: stringNum,
                                        name: "",
                                        fontSize: "10",
                                        nameTextStyle: {
                                            color: "#fff",
                                            padding: [5, 0, 0, 20],
                                            fontSize: 10,
                                        },
                                    },
                                ],
                            },
                        ],
                    });
                } else {
                    window.location.href = "http://staff.risfond.com/signin.aspx";
                }
            });
        },

        // 业绩分布
        topRightDataTwo() {
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
            };

            GetRegionalMonthPerfomanceInfoByDateRange(param).then((res) => {
                var arrMonth = [
                    "1月",
                    "2月",
                    "3月",
                    "4月",
                    "5月",
                    "6月",
                    "7月",
                    "8月",
                    "9月",
                    "10月",
                    "11月",
                    "12月",
                ];
                var arrData1 = [];
                var arrData2 = [];
                res.Data.forEach((e) => {
                    arrData1.push((e.PerformanceAmount / 10000).toFixed(2));
                    arrData2.push(e.CompletedProgress.toFixed(2));
                });

                let topRight = this.$echarts.init(document.getElementById("topRight"));
                topRight.setOption({
                    tooltip: {
                        trigger: "axis",
                        formatter: "{b0}<br/>{a0}: {c0}万<br />{a1}: {c1}%",
                        axisPointer: {
                            type: "cross",
                            crossStyle: {
                                color: this.isChildText ? "#000" : "#999",
                            },
                        },
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "25%",
                        top: "8%",

                        containLabel: true,
                    },
                    legend: {
                        data: ["累计业绩", "完成进度"],
                        right: "0%",
                        bottom: "6%",
                        left: "center",
                        itemWidth: 10,
                        itemHeight: 10,
                        textStyle: {
                            color: this.isChildText ? "#000" : "#f2f2f2",
                            fontSize: 10,
                        },
                    },
                    xAxis: [
                        {
                            type: "category",
                            data: arrMonth,
                            axisPointer: {
                                type: "shadow",
                            },
                            axisLabel: {
                                interval: 0,
                                color: this.isTextColor,
                            },
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#404666", //左边线的颜色
                                    width: "2", //坐标线的宽度
                                },
                            },
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                            min: 0,
                            //   max: arrOne,
                            //   interval: 50,
                            axisLabel: {
                                color: this.isTextColor,
                            },
                            splitLine: {
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#404666", //左边线的颜色
                                    width: "2", //坐标线的宽度
                                },
                            },
                        },
                        {
                            type: "value",
                            show: true,
                            min: 0,
                            axisLabel: {
                                color: this.isTextColor,
                                formatter: "{value} %",
                            },
                            splitLine: {
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#404666", //左边线的颜色
                                    width: "2", //坐标线的宽度
                                },
                            },
                        },
                    ],
                    series: [
                        {
                            name: "累计业绩",
                            type: "bar",
                            barWidth: 25,
                            itemStyle: {
                                normal: {
                                    color: "#1C82FF",
                                },
                            },
                            data: arrData1,
                        },
                        {
                            name: "完成进度",
                            type: "line",
                            yAxisIndex: 1,
                            itemStyle: {
                                normal: {
                                    color: "#1FFD8A",
                                },
                            },
                            data: arrData2,
                        },
                    ],
                });
            });
        },
        topRightData() {
            let param = this.params;
            GetRegionalMonthPerfomanceInfo(param).then((res) => {
                var arrMonth = [];
                var arrData1 = [];
                var arrData2 = [];
                var arrOne = res.Data[0].PerformanceAmount;
                res.Data.forEach((e) => {
                    arrMonth.push(e.Month + "月");
                    arrData1.push((e.PerformanceAmount / 10000).toFixed(2));
                    arrData2.push(e.CompletedProgress.toFixed(2));
                });

                let topRight = this.$echarts.init(document.getElementById("topRight"));
                topRight.setOption({
                    tooltip: {
                        trigger: "axis",
                        formatter: "{b0}<br/>{a0}: {c0}万<br />{a1}: {c1}%",
                        axisPointer: {
                            type: "cross",
                            crossStyle: {
                                color: this.isChildText ? "#000" : "#999",
                            },
                        },
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "25%",
                        top: "8%",

                        containLabel: true,
                    },
                    legend: {
                        data: ["累计业绩", "完成进度"],
                        right: "0%",
                        bottom: "6%",
                        left: "center",
                        itemWidth: 10,
                        itemHeight: 10,
                        textStyle: {
                            color: this.isChildText ? "#000" : "#f2f2f2",
                            fontSize: 10,
                        },
                    },
                    xAxis: [
                        {
                            type: "category",
                            data: arrMonth,
                            axisPointer: {
                                type: "shadow",
                            },
                            axisLabel: {
                                interval: 0,
                                color: this.isTextColor,
                            },
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#404666", //左边线的颜色
                                    width: "2", //坐标线的宽度
                                },
                            },
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                            min: 0,
                            //   max: arrOne,
                            //   interval: 50,
                            axisLabel: {
                                color: this.isTextColor,
                            },
                            splitLine: {
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#404666", //左边线的颜色
                                    width: "2", //坐标线的宽度
                                },
                            },
                        },
                        {
                            type: "value",
                            show: true,
                            min: 0,
                            axisLabel: {
                                color: this.isTextColor,
                                formatter: "{value} %",
                            },
                            splitLine: {
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#404666", //左边线的颜色
                                    width: "2", //坐标线的宽度
                                },
                            },
                        },
                    ],
                    series: [
                        {
                            name: "累计业绩",
                            type: "bar",
                            barWidth: 25,
                            itemStyle: {
                                normal: {
                                    color: "#1C82FF",
                                },
                            },
                            data: arrData1,
                        },
                        {
                            name: "完成进度",
                            type: "line",
                            yAxisIndex: 1,
                            itemStyle: {
                                normal: {
                                    color: "#1FFD8A",
                                },
                            },
                            data: arrData2,
                        },
                    ],
                });
            });

            
        },
        // 人选推荐数据
        middleLeftDataTwo() {
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
            };
            GetRegionalMonthRecommendByDateRange(param).then((res) => {
                var xData = [];
                var yData1 = [];
                var yData2 = [];
                var yData3 = [];
                var yData4 = [];

                res.Data.X.forEach((e) => {
                    xData.push(e + "月");
                });
                res.Data.TuijianCount.forEach((e) => {
                    yData1.push(e);
                });
                res.Data.YuyueCount.forEach((e) => {
                    yData2.push(e);
                });
                res.Data.OfferCount.forEach((e) => {
                    yData3.push(e);
                });
                res.Data.RuzhiCount.forEach((e) => {
                    yData4.push(e);
                });

                let middleLeft = this.$echarts.init(
                    document.getElementById("middleLeft")
                );
                middleLeft.setOption({
                    tooltip: {
                        formatter:
                            "{b0}<br/>{a0}: {c0}人<br />{a1}: {c1}人<br />{a2}: {c2}人<br />{a3}: {c3}人",
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                        },
                    },
                    legend: {
                        x: "center",
                        bottom: "16%",
                        textStyle: {
                            color: this.isChildText ? "#000" : "#f2f2f2",
                            fontSize: 12,
                        },
                        icon: "circle",
                        data: ["推荐", "面试", "offer", "入职"],
                    },
                    grid: {
                        right: "5%",
                        bottom: "25%",
                        left: "2%",
                        top: "3%",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            type: "category",
                            data: xData,
                            nameTextStyle: {
                                color: this.isChildText ? "#000" : "#d4ffff",
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisTick: {
                                show: false,
                            },
                            axisLabel: {
                                show: true,
                                interval: 0,
                                rotate: -45, //代表逆时针旋转45度
                                textStyle: {
                                    color: this.isTextColor,
                                    fontSize: 10,
                                },
                                //interval:0,
                                //rotate:30
                            },
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                            nameTextStyle: {
                                color: this.isChildText ? "#000" : "#d4ffff",
                            },
                            position: "left",
                            axisLine: {
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            splitLine: {
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisLabel: {
                                color: this.isChildText ? "#000" : "#d4ffff",
                                fontSize: 12,
                                interval: 0,
                                rotate: 35, //代表逆时针旋转45度
                            },
                        },
                    ],
                    series: [
                        {
                            name: "推荐",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 5,
                            itemStyle: {
                                normal: {
                                    color: "#1C82FF",
                                },
                            },
                            data: yData1,
                        },
                        {
                            name: "面试",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 5,
                            itemStyle: {
                                normal: {
                                    color: "#48E3EC",
                                },
                            },
                            data: yData2,
                        },
                        {
                            name: "offer",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 5,
                            itemStyle: {
                                normal: {
                                    color: "#FFDF38",
                                },
                            },
                            data: yData3,
                        },
                        {
                            name: "入职",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 5,
                            itemStyle: {
                                normal: {
                                    color: "#1FFD8A",
                                },
                            },
                            data: yData4,
                        },
                    ],
                });
            });
        },
        middleLeftData() {
            let param = this.params;

            GetRegionalMonthRecommend(param).then((res) => {
                var xData = [];
                var yData1 = [];
                var yData2 = [];
                var yData3 = [];
                var yData4 = [];

                res.Data.forEach((e) => {
                    xData.push(e.Month + "月");
                    yData1.push(e.RecommendCount);
                    yData2.push(e.InterViewCount);
                    yData3.push(e.OfferCount);
                    yData4.push(e.EntryCount);
                });

                let middleLeft = this.$echarts.init(
                    document.getElementById("middleLeft")
                );
                middleLeft.setOption({
                    tooltip: {
                        formatter:
                            "{b0}<br/>{a0}: {c0}人<br />{a1}: {c1}人<br />{a2}: {c2}人<br />{a3}: {c3}人",
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                        },
                    },
                    legend: {
                        x: "center",
                        bottom: "16%",
                        textStyle: {
                            color: this.isChildText ? "#000" : "#f2f2f2",
                            fontSize: 12,
                        },
                        icon: "circle",
                        data: ["推荐", "面试", "offer", "入职"],
                    },
                    grid: {
                        right: "5%",
                        bottom: "25%",
                        left: "2%",
                        top: "3%",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            type: "category",
                            data: xData,
                            nameTextStyle: {
                                color: this.isChildText ? "#000" : "#d4ffff",
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisTick: {
                                show: false,
                            },
                            axisLabel: {
                                show: true,
                                interval: 0,
                                rotate: -45, //代表逆时针旋转45度
                                textStyle: {
                                    color: this.isTextColor,
                                    fontSize: 10,
                                },
                                //interval:0,
                                //rotate:30
                            },
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                            nameTextStyle: {
                                color: this.isChildText ? "#000" : "#d4ffff",
                            },
                            position: "left",
                            axisLine: {
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            splitLine: {
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisLabel: {
                                color: this.isChildText ? "#000" : "#d4ffff",
                                fontSize: 12,
                                interval: 0,
                                rotate: 35, //代表逆时针旋转45度
                            },
                        },
                    ],
                    series: [
                        {
                            name: "推荐",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 5,
                            itemStyle: {
                                normal: {
                                    color: "#1C82FF",
                                },
                            },
                            data: yData1,
                        },
                        {
                            name: "面试",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 5,
                            itemStyle: {
                                normal: {
                                    color: "#48E3EC",
                                },
                            },
                            data: yData2,
                        },
                        {
                            name: "offer",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 5,
                            itemStyle: {
                                normal: {
                                    color: "#FFDF38",
                                },
                            },
                            data: yData3,
                        },
                        {
                            name: "入职",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 5,
                            itemStyle: {
                                normal: {
                                    color: "#1FFD8A",
                                },
                            },
                            data: yData4,
                        },
                    ],
                });
            });
        },
        // 人选推荐漏斗
        middleRightDataTwo() {
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
            };
            GetRegionalRecommendPersonByDateRange(param).then((res) => {
                var getname = ["推给客户", "客户面试", "确认offer", "成功入职"];
                var arr = [];
                arr.push(res.Data);
                var arrData1 = "";
                var arrData2 = "";
                var arrData3 = "";
                var arrData4 = "";
                arrData1 = res.Data.RecommendCount;
                arrData2 = res.Data.InterViewCount;
                arrData3 = res.Data.OfferCount;
                arrData4 = res.Data.EntryCount;
                var getvalue = [arrData1, arrData2, arrData3, arrData4];

                let middleRight = this.$echarts.init(
                    document.getElementById("middleRight")
                );

                var data = [];
                for (var i = 0; i < getname.length; i++) {
                    data.push({
                        name: getname[i],
                        value: getvalue[i],
                    });
                }
                var percent = [
                    { value: arrData1, name: "推给客户", num: 23334686 },
                    { value: arrData2, name: "客户面试", num: 756141 },
                    { value: arrData3, name: "确认offer", num: 1447148 },
                    { value: arrData4, name: "成功入职", num: 523833 },
                ];
                middleRight.setOption({
                    tooltip: {
                        trigger: "item",
                        formatter: "{b} : {c}",
                    },
                    grid: {
                        top: "8%",
                        left: "2%",
                        right: "2%",
                        bottom: "8%",
                        containLabel: false,
                        formatter: "{d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        pageIconColor: "#1C82FF",
                        pageTextStyle: {
                            color: "#fff", //翻页数字颜色
                        },
                        borderWidth: 0,
                        icon: "rect",
                        x: "center",
                        bottom: 3,

                        type: "scroll",
                        width: 240,
                        itemGap: 20,
                        itemWidth: 10,
                        itemHeight: 10,
                        data: ["推给客户", "客户面试", "确认offer", "成功入职"],
                        textStyle: {
                            fontSize: "12",
                            color: this.isTextColor,
                        },
                    },
                    calculable: false,
                    series: [
                        {
                            name: "",
                            type: "funnel",
                            left: "20%",
                            bottom: "15%",
                            top: "5%",
                            width: "40%",
                            gap: 3,
                            borderWidth: 0,
                            minSize: "10%",
                            maxSize: "80%",
                            labelLine: {
                                length: 100,
                                show: false,
                            },
                            label: {
                                show: false,
                                formatter: "{b|{b}} " + "{b|:}" + "\n\n{a|{c}}",
                                rich: {
                                    a: {
                                        color: "#fff",
                                        fontSize: 12,
                                    },
                                    b: {
                                        color: "#fff",
                                        fontSize: 12,
                                    },
                                },
                            },
                            data: [
                                {
                                    value: arrData1,
                                    name: "推给客户",

                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },

                                    itemStyle: {
                                        color: "#1C82FF",
                                        borderWidth: 0,
                                    },
                                },
                                {
                                    value: arrData2,
                                    name: "客户面试",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#1FFD8A",
                                        borderWidth: 0,
                                    },
                                },
                                {
                                    value: arrData3,
                                    name: "确认offer",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#00F2DD",
                                        borderWidth: 0,
                                    },
                                },
                                {
                                    value: arrData4,
                                    name: "成功入职",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#8E5FFF",
                                        borderWidth: 0,
                                    },
                                },
                            ],
                        },
                        {
                            name: "",
                            type: "funnel",
                            gap: 60,
                            top: "15%",
                            bottom: "23%",
                            left: "1%",
                            label: {
                                normal: {
                                    formatter: function (value) {
                                        // return value.data.value +'%';
                                        if (value.data.name == "推给客户") {
                                            return "";
                                        } else if (value.data.name == "客户面试") {
                                            return (
                                                "推荐面试比:" +
                                                (
                                                    (res.Data.InterViewCount / res.Data.RecommendCount) *
                                                    100
                                                ).toFixed(2) +
                                                "%"
                                            );
                                        } else if (value.data.name == "确认offer") {
                                            return (
                                                "面试offer比:" +
                                                (
                                                    (res.Data.OfferCount / res.Data.InterViewCount) *
                                                    100
                                                ).toFixed(2) +
                                                "%"
                                            );
                                        } else if (value.data.name == "成功入职") {
                                            return (
                                                "offer入职比:" +
                                                (
                                                    (res.Data.EntryCount / res.Data.OfferCount) *
                                                    100
                                                ).toFixed(2) +
                                                "%"
                                            );
                                        }
                                    },
                                    textStyle: {
                                        color: this.isTextColor,
                                        fontSize: 10,
                                    },
                                },
                            },

                            itemStyle: {
                                fontSize: 12,
                                normal: {
                                    color: "transparent",
                                    borderWidth: 0,
                                    opacity: 1,
                                },
                            },
                            data: percent,
                        },
                    ],
                });
            });

        },
        middleRightData() {
            let param = this.params;
            GetRegionalRecommendPerson(param).then((res) => {
                var getname = ["推给客户", "客户面试", "确认offer", "成功入职"];
                var arr = [];
                arr.push(res.Data);
                var arrData1 = "";
                var arrData2 = "";
                var arrData3 = "";
                var arrData4 = "";
                arrData1 = res.Data.RecommendCount;
                arrData2 = res.Data.InterViewCount;
                arrData3 = res.Data.OfferCount;
                arrData4 = res.Data.EntryCount;
                var getvalue = [arrData1, arrData2, arrData3, arrData4];

                let middleRight = this.$echarts.init(
                    document.getElementById("middleRight")
                );

                var data = [];
                for (var i = 0; i < getname.length; i++) {
                    data.push({
                        name: getname[i],
                        value: getvalue[i],
                    });
                }
                var percent = [
                    { value: arrData1, name: "推给客户", num: 23334686 },
                    { value: arrData2, name: "客户面试", num: 756141 },
                    { value: arrData3, name: "确认offer", num: 1447148 },
                    { value: arrData4, name: "成功入职", num: 523833 },
                ];
                middleRight.setOption({
                    tooltip: {
                        trigger: "item",
                        formatter: "{b} : {c}",
                    },
                    grid: {
                        top: "8%",
                        left: "2%",
                        right: "2%",
                        bottom: "8%",
                        containLabel: false,
                        formatter: "{d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        pageIconColor: "#1C82FF",
                        pageTextStyle: {
                            color: "#fff", //翻页数字颜色
                        },
                        borderWidth: 0,
                        icon: "rect",
                        x: "center",
                        bottom: 3,

                        type: "scroll",
                        width: 240,
                        itemGap: 20,
                        itemWidth: 10,
                        itemHeight: 10,
                        data: ["推给客户", "客户面试", "确认offer", "成功入职"],
                        textStyle: {
                            fontSize: "12",
                            color: this.isTextColor,
                        },
                    },
                    calculable: false,
                    series: [
                        {
                            name: "",
                            type: "funnel",
                            left: "20%",
                            bottom: "15%",
                            top: "5%",
                            width: "40%",
                            gap: 3,
                            borderWidth: 0,
                            minSize: "10%",
                            maxSize: "80%",
                            labelLine: {
                                length: 100,
                                show: false,
                            },
                            label: {
                                show: false,
                                formatter: "{b|{b}} " + "{b|:}" + "\n\n{a|{c}}",
                                rich: {
                                    a: {
                                        color: "#fff",
                                        fontSize: 12,
                                    },
                                    b: {
                                        color: "#fff",
                                        fontSize: 12,
                                    },
                                },
                            },
                            data: [
                                {
                                    value: arrData1,
                                    name: "推给客户",

                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },

                                    itemStyle: {
                                        color: "#1C82FF",
                                        borderWidth: 0,
                                    },
                                },
                                {
                                    value: arrData2,
                                    name: "客户面试",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#1FFD8A",
                                        borderWidth: 0,
                                    },
                                },
                                {
                                    value: arrData3,
                                    name: "确认offer",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#00F2DD",
                                        borderWidth: 0,
                                    },
                                },
                                {
                                    value: arrData4,
                                    name: "成功入职",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#8E5FFF",
                                        borderWidth: 0,
                                    },
                                },
                            ],
                        },
                        {
                            name: "",
                            type: "funnel",
                            gap: 60,
                            top: "15%",
                            bottom: "23%",
                            left: "1%",
                            label: {
                                normal: {
                                    formatter: function (value) {
                                        // return value.data.value +'%';
                                        if (value.data.name == "推给客户") {
                                            return "";
                                        } else if (value.data.name == "客户面试") {
                                            return (
                                                "推荐面试比:" +
                                                (
                                                    (res.Data.InterViewCount / res.Data.RecommendCount) *
                                                    100
                                                ).toFixed(2) +
                                                "%"
                                            );
                                        } else if (value.data.name == "确认offer") {
                                            return (
                                                "面试offer比:" +
                                                (
                                                    (res.Data.OfferCount / res.Data.InterViewCount) *
                                                    100
                                                ).toFixed(2) +
                                                "%"
                                            );
                                        } else if (value.data.name == "成功入职") {
                                            return (
                                                "offer入职比:" +
                                                (
                                                    (res.Data.EntryCount / res.Data.OfferCount) *
                                                    100
                                                ).toFixed(2) +
                                                "%"
                                            );
                                        }
                                    },
                                    textStyle: {
                                        color: this.isTextColor,
                                        fontSize: 10,
                                    },
                                },
                            },

                            itemStyle: {
                                fontSize: 12,
                                normal: {
                                    color: "transparent",
                                    borderWidth: 0,
                                    opacity: 1,
                                },
                            },
                            data: percent,
                        },
                    ],
                });
            });
        },

        // 业务顾问职级分布
        middleRightTwoDataTwo() {
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
                isIncomeAmount: 0,
            };
            GetRegionalCounselorPPerformanceByDateRange(param).then((res) => {
                if (this.staffCount !== 0) this.staffCount = 0;
                var arr = [];
                res.Data.forEach((e) => {
                    this.staffCount += e.StaffCount;
                    const item = {
                        product: e.Position,
                        "人数（人）": e.StaffCount,
                        "回款（万）": (e.IncomeAmount / 10000).toFixed(2),
                        "业绩（万）": (e.PerformanceAmount / 10000).toFixed(2),
                    };
                    arr.push(item);
                });
                let middleRightTwo = this.$echarts.init(
                    document.getElementById("middleRightTwo")
                );
                middleRightTwo.setOption({
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                        },
                    },
                    grid: {
                        left: "2%",
                        right: "4%",
                        bottom: "15%",
                        top: "6%",
                        containLabel: true,
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "4%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 10,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    xAxis: {
                        type: "category",
                        data: ["管理岗", "中级业务岗", "初级业务岗", "其他岗"],
                        axisLine: {
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        axisLabel: {
                            // interval: 0,
                            // rotate: 40,
                            textStyle: {
                                fontFamily: "Microsoft YaHei",
                                color: this.isTextColor,
                            },
                        },
                    },
                    yAxis: {
                        type: "value",
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        axisLabel: {
                            textStyle: {
                                fontFamily: "Microsoft YaHei",
                                color: this.isTextColor,
                            },
                        },
                    },
                    dataset: {
                        source: arr,
                    },
                    // Declare several bar series, each will be mapped
                    // to a column of dataset.source by default.
                    series: [
                        {
                            type: "bar",
                            barWidth: 20,
                            itemStyle: {
                                normal: {
                                    color: "#00F2DD",
                                },
                            },
                        },
                        {
                            type: "bar",
                            barWidth: 20,
                            itemStyle: {
                                normal: {
                                    color: "#8E5FFF",
                                },
                            },
                        },
                        {
                            type: "bar",
                            barWidth: 20,
                            itemStyle: {
                                normal: {
                                    color: "#F8D135",
                                },
                            },
                        },
                    ],
                });
            });
        },
        middleRightTwoData() {
            let param = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                isIncomeAmount: 0,
                ticket: this.urlData,
            };
            GetRegionalCounselorPPerformance(param).then((res) => {
                if (this.staffCount !== 0) this.staffCount = 0;
                var arr = [];
                res.Data.forEach((e) => {
                    this.staffCount += e.StaffCount;
                    const item = {
                        product: e.Position,
                        "人数（人）": e.StaffCount,
                        "回款（万）": (e.IncomeAmount / 10000).toFixed(2),
                        "业绩（万）": (e.PerformanceAmount / 10000).toFixed(2),
                    };
                    arr.push(item);
                });
                let middleRightTwo = this.$echarts.init(
                    document.getElementById("middleRightTwo")
                );
                middleRightTwo.setOption({
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                        },
                    },
                    grid: {
                        left: "2%",
                        right: "4%",
                        bottom: "15%",
                        top: "6%",
                        containLabel: true,
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "4%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 10,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    xAxis: {
                        type: "category",
                        data: ["管理岗", "中级业务岗", "初级业务岗", "其他岗"],
                        axisLine: {
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        axisLabel: {
                            // interval: 0,
                            // rotate: 40,
                            textStyle: {
                                fontFamily: "Microsoft YaHei",
                                color: this.isTextColor,
                            },
                        },
                    },
                    yAxis: {
                        type: "value",
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        axisLabel: {
                            textStyle: {
                                fontFamily: "Microsoft YaHei",
                                color: this.isTextColor,
                            },
                        },
                    },
                    dataset: {
                        source: arr,
                    },
                    // Declare several bar series, each will be mapped
                    // to a column of dataset.source by default.
                    series: [
                        {
                            type: "bar",
                            barWidth: 20,
                            itemStyle: {
                                normal: {
                                    color: "#00F2DD",
                                },
                            },
                        },
                        {
                            type: "bar",
                            barWidth: 20,
                            itemStyle: {
                                normal: {
                                    color: "#8E5FFF",
                                },
                            },
                        },
                        {
                            type: "bar",
                            barWidth: 20,
                            itemStyle: {
                                normal: {
                                    color: "#F8D135",
                                },
                            },
                        },
                    ],
                });
            });
        },
        // 业务顾问学历分布
        bottomOnedDataTwo() {
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
                isIncomeAmount: 0,
            };
            GetRegionalCounselorEducationByDateRange(param).then((res) => {
                var arr = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.EducationText,
                        value: e.StaffCount,
                    };
                    arr.push(item);
                });

                let bottomOned = this.$echarts.init(
                    document.getElementById("bottomOned")
                );
                let color = ["#FF6969", "#1C82FF", "#1FFD8A", "#F8D135", "#00F2DD"];
                let echartData = arr;

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomOned.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "12%",
                        top: "3%",
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "4%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 10,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "45%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            labelLine: {
                                show: true,
                                length: 5,
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    borderWidth: 0,
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },
        bottomOnedData() {
            let param = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                isIncomeAmount: 0,
                ticket: this.urlData,
            };
            GetRegionalCounselorEducation(param).then((res) => {
                var arr = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.EducationText,
                        value: e.StaffCount,
                    };
                    arr.push(item);
                });

                let bottomOned = this.$echarts.init(
                    document.getElementById("bottomOned")
                );
                let color = ["#FF6969", "#1C82FF", "#1FFD8A", "#F8D135", "#00F2DD"];
                let echartData = arr;

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomOned.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "12%",
                        top: "3%",
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "4%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 10,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "45%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            labelLine: {
                                show: true,
                                length: 5,
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    borderWidth: 0,
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },
        bottomTwoData1() {
            let params = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                ticket: this.urlData,
                isIncomeAmount: 0,
            };
            GetRegionalCounselorAge(params).then((res) => {
                var arrDara = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.Age,
                        value: e.StaffCount,
                    };
                    arrDara.push(item);
                });

                let bottomTwo = this.$echarts.init(
                    document.getElementById("bottomTwo")
                );
                let color = ["#FF6969", "#1EF787", "#62A8FD", "#F8D135", "#00F2DD"];
                let echartData = arrDara;

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomTwo.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "10%",
                        top: "1%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        //   scrollDataIndex: 3,
                        pageTextStyle: {
                            color: "#fff", //翻页数字颜色
                        }, //翻页数字设置
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "2%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 10,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "45%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            labelLine: {
                                show: true,
                                length: 5,
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    borderWidth: 0,
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },

        // 业务顾问年龄分布
        bottomTwoDataTwo() {
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
                isIncomeAmount: 0,
            };
            GetRegionalCounselorAgeByDateRange(param).then((res) => {
                var arrDara = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.Age,
                        value: e.StaffCount,
                    };
                    arrDara.push(item);
                });

                let bottomTwo = this.$echarts.init(
                    document.getElementById("bottomTwo")
                );
                let color = ["#FF6969", "#1EF787", "#62A8FD", "#F8D135", "#00F2DD"];
                let echartData = arrDara;

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomTwo.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "10%",
                        top: "1%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        //   scrollDataIndex: 3,
                        pageTextStyle: {
                            color: "#fff", //翻页数字颜色
                        }, //翻页数字设置
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "2%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 10,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "45%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            labelLine: {
                                show: true,
                                length: 5,
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    borderWidth: 0,
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },
        bottomTwoData() {
            let params = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                ticket: this.urlData,
                isIncomeAmount: 0,
            };
            GetRegionalCounselorAge(params).then((res) => {
                var arrDara = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.Age,
                        value: e.StaffCount,
                    };
                    arrDara.push(item);
                });

                let bottomTwo = this.$echarts.init(
                    document.getElementById("bottomTwo")
                );
                let color = ["#FF6969", "#1EF787", "#62A8FD", "#F8D135", "#00F2DD"];
                let echartData = arrDara;

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomTwo.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "10%",
                        top: "1%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        //   scrollDataIndex: 3,
                        pageTextStyle: {
                            color: "#fff", //翻页数字颜色
                        }, //翻页数字设置
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "2%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 10,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "45%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            labelLine: {
                                show: true,
                                length: 5,
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    borderWidth: 0,
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },

        // 业务顾问工龄分布
        bottomThreeDataTwo() {
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
            };
            GetRegionalCounselorWorkyearByDateRange(param).then((res) => {
                var arr = [];
                res.Data.forEach((e) => {
                    if (e.WorkYear == 7) {
                        e.WorkYear = "7年以上";
                    }
                    if (e.WorkYear == 0) {
                        e.WorkYear = "1年以内";
                    }
                    const item = {
                        //   if(){}
                        name: e.WorkYear + "年",
                        value: e.StaffCount,
                    };
                    if (item.name == "1年以内年") {
                        item.name = "1年以内";
                    }
                    if (item.name == "7年以上年") {
                        item.name = "7年以上";
                    }

                    arr.push(item);
                });

                let bottomThree = this.$echarts.init(
                    document.getElementById("bottomThree")
                );
                let color = [
                    "#62A8FD",
                    "#1FFD8A",
                    "#1C82FF",
                    "#F8D135",
                    "#FF6969",
                    "#FFB377",
                    "#9CFFE8",
                ];
                let echartData = arr;

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomThree.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "12%",
                        top: "1%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        //   scrollDataIndex: 3,
                        pageTextStyle: {
                            color: this.isTextColor, //翻页数字颜色
                        }, //翻页数字设置
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "2%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 12,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "45%"],
                            data: arr,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            labelLine: {
                                show: true,
                                length: 5,
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    borderWidth: 0,
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },
        bottomThreeData() {
            let param = this.params;
            GetRegionalCounselorWorkyear(param).then((res) => {
                var arr = [];
                res.Data.forEach((e) => {
                    if (e.WorkYear == 7) {
                        e.WorkYear = "7年以上";
                    }
                    if (e.WorkYear == 0) {
                        e.WorkYear = "1年以内";
                    }
                    const item = {
                        //   if(){}
                        name: e.WorkYear + "年",
                        value: e.StaffCount,
                    };
                    if (item.name == "1年以内年") {
                        item.name = "1年以内";
                    }
                    if (item.name == "7年以上年") {
                        item.name = "7年以上";
                    }

                    arr.push(item);
                });

                let bottomThree = this.$echarts.init(
                    document.getElementById("bottomThree")
                );
                let color = [
                    "#62A8FD",
                    "#1FFD8A",
                    "#1C82FF",
                    "#F8D135",
                    "#FF6969",
                    "#FFB377",
                    "#9CFFE8",
                ];
                let echartData = arr;

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomThree.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "12%",
                        top: "1%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        //   scrollDataIndex: 3,
                        pageTextStyle: {
                            color: this.isTextColor, //翻页数字颜色
                        }, //翻页数字设置
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "2%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 12,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "45%"],
                            data: arr,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            labelLine: {
                                show: true,
                                length: 5,
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    borderWidth: 0,
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },

        // 业务顾问性别分布
        bottomFourDataTwo() {
            let param = {
                 regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
            };
            GetRegionalCounselorLevelByDateRange(param).then((res) => {
                var arr = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.Level,
                        value: e.StaffCount,
                    };
                    arr.push(item);
                });

                let bottomFour = this.$echarts.init(
                    document.getElementById("bottomFour")
                );
                let color = ["#8993FF", "#F8D135","#00F2DD","#FFB377","#1FFD8A","#FA6767"];

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomFour.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "10%",
                        top: "1%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        //   scrollDataIndex: 3,
                        pageTextStyle: {
                            color: this.isTextColor, //翻页数字颜色
                        }, //翻页数字设置
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "4%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 12,
                                    color: this.isTextColor,
                                },
                            },
                        },
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "45%"],
                            data: arr,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            labelLine: {
                                show: true,
                                length: 5,
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    borderWidth: 0,
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },
        bottomFourData() {
            let param = {
                 year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                ticket: this.urlData,
            };
            GetRegionalCounselorLevel(param).then((res) => {
                var arr = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.Level,
                        value: e.StaffCount,
                    };
                    arr.push(item);
                });

                let bottomFour = this.$echarts.init(
                    document.getElementById("bottomFour")
                );
                let color = ["#8993FF", "#F8D135","#00F2DD","#FFB377","#1FFD8A","#FA6767"];

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomFour.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "10%",
                        top: "1%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        //   scrollDataIndex: 3,
                        pageTextStyle: {
                            color: this.isTextColor, //翻页数字颜色
                        }, //翻页数字设置
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "4%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 12,
                                    color: this.isTextColor,
                                },
                            },
                        },
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "45%"],
                            data: arr,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            labelLine: {
                                show: true,
                                length: 5,
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    borderWidth: 0,
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },

        // 业务顾问户籍分布
        bottomFiveData(pName, Chinese_) {
            // 基于准备好的dom，初始化echarts实例
            var myChartContainer = document.getElementById("bottomFive");
            var myChartChina = this.$echarts.init(myChartContainer);
            let param = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                ticket: this.urlData,
            };
            var list = [];
            GetRegionalBusinessConsultantLocation(param).then((res) => {
                let Data = [
                    "北京市",
                    "天津市",
                    "上海市",
                    "重庆市",
                    "河北省",
                    "河南省",
                    "云南省",
                    "辽宁省",
                    "黑龙江省",
                    "湖南省",
                    "安徽省",
                    "山东省",
                    "新疆维吾尔自治区",
                    "江苏省",
                    "浙江省",
                    "江西省",
                    "湖北省",
                    "广西壮族自治区",
                    "甘肃省",
                    "山西省",
                    "内蒙古自治区",
                    "陕西省",
                    "吉林省",
                    "福建省",
                    "贵州省",
                    "广东省",
                    "青海省",
                    "西藏自治区",
                    "四川省",
                    "宁夏回族自治区",
                    "海南省",
                    "台湾省",
                    "香港特别行政区",
                    "澳门特别行政区",
                ];
                var numData = 2;

                if (res.Data.length === 0) {
                    numData;
                } else {
                    numData = res.Data[0].StaffCount;
                }
                res.Data.forEach((e) => {
                    var index1 = Data.indexOf(e.NativeLocationName);
                    if (index1 >= 0) {
                        let name = Data[index1];
                        Data.splice(index1, 1);
                        var item = {
                            name: name,
                            value: e.StaffCount,
                        };
                        list.push(item);
                    }
                });
                for (var i = 0; i < Data.length; i++) {
                    let item = {
                        name: Data[i],
                        value: 0,
                    };
                    list.push(item);
                }

                var optionMap = {
                    tooltip: {},
                    legend: {
                        orient: "vertical",
                        left: "left",
                        data: [""],
                    },
                    visualMap: {
                        min: 1,
                        max: numData,
                        left: "0%",
                        itemHeight: 90,
                        itemWidth: 10,
                        bottom: "bottom",
                        calculable: false,
                        color: ["#547CCE", "#fff"],
                    },
                    selectedMode: "single",
                    series: [
                        {
                            name: "",
                            type: "map",
                            zoom: 1.7,
                            roam: true,
                            top: "23%",
                            bottom: "22%",
                            mapType: "china",
                            itemStyle: {
                                normal: {
                                    borderColor: "rgba(0, 0, 0, 0.2)",
                                },
                                emphasis: {
                                    shadowOffsetX: 0,
                                    shadowOffsetY: 0,
                                    shadowBlur: 20,
                                    borderWidth: 0,
                                    shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                            },
                            showLegendSymbol: false,
                            label: {
                                normal: {
                                    show: false,
                                },
                                emphasis: {
                                    show: false,
                                },
                            },
                            data: list,
                        },
                    ],
                };

                myChartChina.setOption(optionMap);
                window.onresize = function () {
                    //   resizeMyChartContainer();
                    myChartChina.resize();
                };
            });
        },

        changIconsBlockPosition(str, index) {
            if (str === "enter") {
                if (index === 1) {
                    this.$refs.iconsFir.$el.classList.add("cont-position-act");
                }
                if (index == 2) {
                    this.$refs.iconsSec.$el.classList.add("cont-position-act");
                }
                if (index == 3) {
                    this.$refs.iconsThr.$el.classList.add("cont-position-act");
                }
                if (index == 4) {
                    this.$refs.iconsFou.$el.classList.add("cont-position-act");
                }
                if (index == 5) {
                    this.$refs.iconsFiv.$el.classList.add("cont-position-act");
                }
                if (index == 6) {
                    this.$refs.iconsSix.$el.classList.add("cont-position-act");
                }
                if (index == 7) {
                    this.$refs.iconsSev.$el.classList.add("cont-position-act");
                }
                if (index == 8) {
                    this.$refs.iconsEig.$el.classList.add("cont-position-act");
                }
                if (index == 9) {
                    this.$refs.iconsNin.$el.classList.add("cont-position-act");
                }
            } else {
                this.$refs.iconsFir.$el.classList.remove("cont-position-act");
                this.$refs.iconsSec.$el.classList.remove("cont-position-act");
                this.$refs.iconsThr.$el.classList.remove("cont-position-act");
                this.$refs.iconsFou.$el.classList.remove("cont-position-act");
                this.$refs.iconsFiv.$el.classList.remove("cont-position-act");
                this.$refs.iconsSix.$el.classList.remove("cont-position-act");
                this.$refs.iconsSev.$el.classList.remove("cont-position-act");
                this.$refs.iconsEig.$el.classList.remove("cont-position-act");
                this.$refs.iconsNin.$el.classList.remove("cont-position-act");
            }
        },
        changeTextColor(status) {
            this.isChildText = status;
        },
        download(idName, imgName = "chart") {
            exportImg(idName, imgName);
        },
    },
};
</script>

<style scoped>
.container {
    height: 100vh;
    padding: 19px 32px;
}

.top-select {
    margin-bottom: 15px;
}

>>>.el-input__inner {
    background: none !important;
    border: 1px solid #1ac9ff !important;
    color: #fff;
}

>>>.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
    background-color: #1e4472 !important;
    color: #ffffff;
}

.el-date-editor .el-range-input {
    background: none !important;
}

>>>.el-date-editor .el-range-input {
    background: none !important;
}

>>>.el-popper[x-placement^="bottom"] {
    margin-top: 0 !important;
}

>>>.el-select-dropdown {
    background-color: none !important;
}

>>>.el-select-dropdown__item.selected {
    background: #1c82ff !important;
    color: #fff;
}

>>>.el-picker-panel {
    background: none !important;
    color: #fff;
}

>>>.el-month-table td .cell,
.el-date-editor .el-range-separator {
    color: #fff;
}

/* 顶部、中间、底部公共样式 */
.top-cont {
    width: 100%;
    height: 24%;
    display: flex;
    justify-content: space-between;
    color: #fff;
}

.top-cont-left {
    width: 49.5%;
    height: 100%;
}

.top-cont-right {
    width: 49.5%;
    height: 100%;
}

.middle-cont {
    margin: 0.8em 0;
    display: flex;
    justify-content: space-between;
}

.middle-cont-left {
    width: 49.5%;
    height: 100%;
    color: #fff;
    display: flex;
    justify-content: space-between;
}

.middle-cont-right {
    width: 49.5%;
    height: 100%;
    color: #fff;
}

.middle-cont,
.bottom-cont {
    width: 100%;
    height: 28%;
}

.width-height {
    width: 100%;
    height: 90%;
}

/* 阴影 */
>>>.dv-border-box-7 .dv-border-svg-container>polyline {
    stroke: #1eb0fc;
}

>>>.dv-border-box-7 .dv-border-svg-container>polyline:nth-child(2),
>>>.dv-border-box-7 .dv-border-svg-container>polyline:nth-child(4) {
    display: none !important;
}

>>>.dv-border-box-7 .dv-bb7-line-width-5 {
    display: none !important;
}

>>>.dv-border-box-7 .dv-bb7-line-width-2 {
    stroke-width: 4;
}

>>>.dv-border-box-7 {
    box-shadow: 0px 0px 10px 0px #7580be inset !important;
}

>>>.dv-border-box-7:hover {
    box-shadow: 0px 0px 10px 0px #ffdf38 inset !important;
}

>>>.dv-border-box-7:hover .right-top polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .left-top polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .right-bottom polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .left-bottom polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

/* 顶部 */
.top-dis {
    display: flex;
    justify-content: space-between;
    height: 85%;
}

.top-left-left {
    width: 70%;
    height: 100%;
    padding: 16px;
}

.top-left-right {
    width: 30%;
    height: 100%;
    padding: 16px;
}

.achievement-title {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    letter-spacing: 1px;
}

.achievement-num {
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 40px;
    letter-spacing: 2px;
}

/* 中间 */
.top-icon-four {
    background: url(../../assets/img/cont-bg-four.png) no-repeat;
}

.top-icon-six {
    background: url(../../assets/img/cont-bg-six.png) no-repeat;
}

.top-icon {
    padding: 5px 92px 5px 12px;
    display: inline-block;
    letter-spacing: 1px;
    font-size: 16px;
    min-width: 92px;
    background-size: 100%;
    /* position: absolute; */
    /* text-align: center; */
    background-position: center;
    height: 32px;
    line-height: 32px;
}

.cont-bg-event {
    /* width: 180px; */
    display: inline-block;
    padding: 5px 92px 5px 12px;
    background: url(../../assets/img/cont-bg-eight.png) no-repeat;
    letter-spacing: 1px;
    font-size: 16px;
    min-width: 136px;
    background-size: 100%;
    position: absolute;
    /* text-align: center; */
    background-position: center;
    height: 32px;
    line-height: 32px;
}

.middle-data {
    height: 15%;
    padding: 16px 0 0 16px;
}

.middle-left-left {
    width: 57%;
}

.middle-left-right {
    width: 41%;
}

.middle-right-container {
    display: flex;
    justify-content: space-between;
    height: 87%;
}

.middle-right-left {
    width: 20%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.middle-right-right {
    width: 80%;
    height: 100%;
}

.people-img {
    width: 112px;
    height: 76px;
    background: url(../../assets/img/people-icon.png) no-repeat;
    background-size: 100%;
    margin-bottom: 20px;
}

.p-p {
    text-align: center;
    margin-bottom: 5px;
}

.p-text {
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffdf38;
    line-height: 30px;
    letter-spacing: 1px;
    text-align: center;
}

.p-text-bot {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
    text-align: center;
}

/* 底部 */
.bottom-dis {
    height: 100%;
    display: flex;
    justify-content: space-between;
}

.bottom-div {
    width: 19%;
    color: #fff;
}

.bottom-height {
    width: 100%;
    height: 80%;
}

.number {
    color: #fff;
    margin-left: 8px;
    margin-top: 10px;
}
</style>

<style>
.to__led-number {
    margin-right: 6px;
    font-size: 36px;
    color: #ffdf38;
    width: 50px !important;
    height: 50px !important;
    line-height: 50px !important;
    text-align: center;
    border: 1px solid #1582a3;
    /* background: #10213b; */
    box-shadow: inset 0px 0px 7px 0px #7580be;
    border-radius: 4px;
    display: inline-block;
    vertical-align: middle;
    box-sizing: border-box;
}

.to__led-number--no {
    width: 9px;
    background: none;
    border: none;
    box-shadow: none;
    color: #fff;
}

/*滚动数字设置*/
.number-item1 {
    text-align: center;
    width: 46px;
    height: 55px;
    line-height: 70px;
    float: left;
    /* background: #10213b; */
    box-shadow: 0px 0px 7px 0px #7580be inset;
    list-style: none;
    font-family: Digital-7;
    font-size: 60px;
    color: #b9d2e8;
    margin-right: 3px;
    display: flex;
    justify-content: center;
    margin-right: 10px;
}

.number-item1 span {
    position: relative;
    display: inline-block;
    margin-right: 18px;
    width: 100%;
    height: 100%;
    writing-mode: vertical-rl;
    text-orientation: unset;
    overflow: hidden;
}

.number-item1 span i {
    font-style: normal;
    position: absolute;
    font-size: 36px;
    top: 12px;
    left: 50%;
    transform: translate(-50%, 0);
    transition: transform 1s ease-in-out;
    letter-spacing: 10px;
    color: #ffdf38;
}

.number-item1:last-child {
    margin-right: 0;
}

@media (min-width: 1279px) and (max-width: 1401px) {
    .number-item1 {
        width: 25px !important;
        height: 40px !important;
        line-height: 40px !important;
    }

    .achievement-title {
        font-size: 14px !important;
    }

    .number-item1 span i {
        font-size: 18px !important;
    }

    .middle-data {
        padding: 10px 0 0 10px;
    }

    .top-icon {
        font-size: 12px !important;
        padding: 0 55px 0 12px !important;
    }

    #top-icon-four {
        padding: 0 20px 0 12px !important;
        width: 110px;
        min-width: 110px;
    }

    .top-left-left,
    .top-left-right {
        padding: 8px !important;
    }

    /* 小屏数字动画 */
    .to__led-number {
        margin-right: 6px;
        font-size: 20px;
        color: #ffdf38;
        width: 22px !important;
        height: 33px !important;
        line-height: 33px !important;
    }

    .to__led-number--no {
        width: 4px;
    }

    .number {
        margin-left: 8px;
        margin-top: 0 !important;
    }
}
</style>

<style scoped>
.chartNum {
    margin: 30px 0px;
    display: flex;
    justify-content: center;
}

.box-items1 {
    width: auto;
    font-family: Digital-7;
    position: relative;
    height: 70px;
    text-align: center;
    list-style: none;
    writing-mode: vertical-lr;
    text-orientation: upright;
    -moz-user-select: none;
    /*火狐*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -ms-user-select: none;
    /*IE10*/
    -khtml-user-select: none;
    /*早期浏览器*/
    user-select: none;
    margin-left: 16px;
    margin-top: 10px;
}

.mark-item span {
    position: absolute;
    width: 100%;
    bottom: 10px;
    writing-mode: vertical-rl;
    text-orientation: revert;
}

.num-right {
    margin-left: 25px;
}

.tongbi {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    letter-spacing: 1px;
}

.bfbNum {
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 42px;
    letter-spacing: 2px;
}

.num-text {
    font-size: 26px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-left: 10px;
    padding-top: 10px;
}

.middle-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
}

.cont-position {
    position: relative;
    left: 112px;
    transition: all 0.3s linear;
}

.cont-position-act {
    left: 0px;
}

.icons-block {
    overflow: hidden;
    margin-right: 6px;
    padding: 4px 2px;
    position: absolute;
    right: 8px;
}

.num-dis {
    display: flex;
    align-items: center;
}

#width-height {
    height: 79%;
}

@media (min-width: 1279px) and (max-width: 1365px) {
    .cont-bg-event {
        width: 110px !important;
        min-width: 110px !important;
        font-size: 12px !important;
        padding: 5px 60px 5px 12px;
    }

    .container {
        height: 90vh;
        padding: 15px 15px;
    }

    .top-cont {
        height: 26%;
    }

    .middle-cont {
        height: 30% !important;
    }

    .bottom-cont {
        height: 30% !important;
    }

    .middle-data1 {
        padding: 0 0 0 16px !important;
    }

    .w1280,
    .dis-top {
        display: flex;
        align-items: center;
        margin-top: 15px;
    }

    .achievement-num {
        font-size: 18px !important;
        text-indent: 13px;
        display: inline-block;
    }

    .number-s {
        font-size: 18px;
    }

    .dis-top {
        width: 100%;
        height: 43%;
        align-items: start;
    }

    .top-left-left {
        width: 63%;
    }

    .top-left-right {
        width: 35%;
    }

    .num-text {
        padding-top: 5px;
        margin-left: 0;
        font-size: 18px;
    }

    .num-dis {
        width: 78%;
        display: flex;
        align-items: start;
    }

    .box-items1 {
        margin-top: 5px;
    }

    .people-img {
        width: 92px !important;
        height: 56px !important;
        margin-bottom: 5px !important;
    }

    .bottom-height {
        height: 80% !important;
    }

    .middle-data {
        height: 18% !important;
        padding: 8px 0 0 8px !important;
    }

    .p-text {
        font-size: 18px !important;
        line-height: 18px !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/dataChart/achievement.vue